import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { PageHeader, Well } from '@pushly/aqe/lib/components'
import { AccountDto } from '@halo/dtos/account.dto'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { AccountService } from '@halo/services/account.service'
import { Container } from 'typescript-ioc/es5'
import { Tabs } from 'antd'
import { noop } from '@pushly/aqe/lib/utils/noop'
import UserRoleList from '@halo/components/user-role-list/user-role-list'
import AccessPolicyList from '@halo/components/access-policy-list/access-policy-list'
import { InternalApiSettingWell } from '@halo/components/data-form-elements/api-settings-well/internal-api-settings-well'

interface IAccountState {
    account?: AccountDto
}

export class AccessControl extends React.Component<any, IAccountState> {
    protected appState: AppState
    protected appService: AppService
    protected accountService: AccountService

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)
        this.accountService = Container.get(AccountService)
    }

    public render() {
        return (
            <div className={classnames('page', 'access-control')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader title="Access Control" onTitleSet={noop} />

                    <Tabs
                        size="small"
                        animated={{ inkBar: false, tabPane: false }}
                        tabPosition="top"
                        activeKey={this.currentTabKey}
                        onChange={this.setCurrentTabKey}
                    >
                        <Tabs.TabPane key="/" tab="Roles">
                            <UserRoleList />
                        </Tabs.TabPane>
                        <Tabs.TabPane key="access-policies" tab="Policies">
                            <AccessPolicyList />
                        </Tabs.TabPane>
                        <Tabs.TabPane key="api-keys" tab="API Keys">
                            <InternalApiSettingWell />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }

    protected get currentTabKey(): string {
        return this.props.match.params.activeTab ?? '/'
    }

    protected setCurrentTabKey = (key: string): void => {
        let fullPath: string = this.props.location.pathname

        if (this.currentTabKey === '/' && key !== '/') {
            fullPath = `${fullPath}/${key}`
        } else if (this.currentTabKey !== '/') {
            const tabPath = `/${this.currentTabKey}`

            if (key === '/') {
                fullPath = fullPath.replace(tabPath, '')
            } else if (fullPath.includes(tabPath)) {
                fullPath = fullPath.replace(tabPath, `/${key}`)
            } else {
                fullPath = `${fullPath}/${key}`
            }
        }

        if (fullPath !== this.props.location.pathname) {
            this.appService.route(fullPath)
        }
    }
}
